import React, { useRef, useEffect, useState } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

// core components
import ShopSidebar from './nav/ShopSidebar';
import ShopTopbar from './nav/ShopTopbar';
import Provider from 'utils/Provider';
import ShopEditProduct from 'shopAdminViews/addProduct/ShopEditProduct';
import ShopAddPromotion from 'shopAdminViews/addPromotion/ShopAddPromotion';
import ShopAddProduct from 'shopAdminViews/addProduct/ShopAddProduct';
import ShopEditPromotion from 'shopAdminViews/addPromotion/ShopEditPromotion';
import Sound from 'react-sound';
import { useSubscription } from '@apollo/react-hooks';
import { gql } from 'apollo-boost';

import routes from 'routes.js';

import newOrderSound from 'assets/sounds/newOrder.mp3';
import updateOrderSound from 'assets/sounds/updateOrder.mp3';

const GET_ORDERS_SUBSCRIPTION = gql`
	subscription createOrder {
		createOrder {
			_id
			user {
				_id
			}
			shipmentModel
			type
			finalPrice
			commission
			createdAt
			finished
			status
			trip {
				_id
				trackId
			}
			tracking {
				trackId
			}
			cart {
				products {
					quantity
					product {
						_id
						title
					}
				}
			}
		}
	}
`;

const UPDATE_ORDERS_SUBSCRIPTION = gql`
	subscription updateOrder {
		updateOrder {
			_id
			user {
				_id
			}
			shipmentModel
			type
			finalPrice
			commission
			createdAt
			finished
			status
			trip {
				_id
				trackId
			}
			tracking {
				trackId
			}
			cart {
				products {
					quantity
					product {
						_id
						title
					}
				}
			}
		}
	}
`;

export default function ShopAdmin(props) {
	// change title of the page in browser tab
	const [pageTitle, setPageTitle] = useState('');
	useEffect(() => {
		let routeName = window.location.pathname.split('/')[2];

		let titleName = routeName
			? routeName
					.replace(/([A-Z])/g, ' $1')
					.replace(/_/g, ' ')
					.toLowerCase()
			: '';
		let titleFinalName = titleName.charAt(0).toUpperCase() + titleName.slice(1);
		setPageTitle(titleFinalName);
		document.title = titleFinalName ? `Spark - ${titleFinalName}` : 'Spark';
	}, [, window.location.pathname.split('/')[2]]);

	const [play, setPlay] = useState(false);
	const [updatePlay, setUpdatePlay] = useState(false);

	const { error: subError, data: subData, loading: subLoading } = useSubscription(GET_ORDERS_SUBSCRIPTION);

	const { error: subUpdateError, data: subUpdateData, loading: subUpdateLoading } = useSubscription(
		UPDATE_ORDERS_SUBSCRIPTION
	);

	useEffect(() => {
		if (subData) {
			setPlay(true);
		}
	}, [subData, subLoading]);

	useEffect(() => {
		if (subUpdateData) {
			setUpdatePlay(true);
		}
	}, [subUpdateData, subUpdateLoading]);

	const scrollRef = useRef(null);
	useEffect(() => {
		scrollRef.current.scrollIntoView();
	}, [window.location.pathname]);

	const [mobileOpen, setMobileOpen] = useState(false);

	useEffect(() => {
		const resizeFunction = () => {
			if (window.innerWidth >= 960) {
				setMobileOpen(false);
			}
		};
		window.addEventListener('resize', resizeFunction);
		return () => window.removeEventListener('resize', resizeFunction);
	}, []);

	const getRoutes = (routes) => {
		return routes.map((prop, key) => {
			if (prop.collapse) {
				return getRoutes(prop.views);
			}
			if (prop.layout === '/shopAdmin') {
				return (
					<Route
						path={prop.layout + prop.path}
						render={() => <prop.component type={props.type} />}
						key={key}
					/>
				);
			} else {
				return null;
			}
		});
	};

	return (
		<Provider>
			<div ref={scrollRef}></div>
			{play && (
				<Sound
					url={newOrderSound}
					playStatus={Sound.status.PLAYING}
					onFinishedPlaying={() => setPlay(false)}
				/>
			)}
			{updatePlay && (
				<Sound
					url={updateOrderSound}
					playStatus={Sound.status.PLAYING}
					onFinishedPlaying={() => setUpdatePlay(false)}
				/>
			)}
			<div className="shopAppShell">
				<ShopSidebar
					routes={routes.filter((route) => route.layout === '/shopAdmin')}
					mobileOpen={mobileOpen}
					onCloseMobile={() => setMobileOpen(false)}
				/>
				<div className="shopAppMain">
					<ShopTopbar title={pageTitle} onOpenMobile={() => setMobileOpen(true)} />
					<div className="shopAppContent">
						<Switch>
							{getRoutes(routes)}
							<Route
								path="/shopAdmin/addPromotion"
								render={() => <ShopAddPromotion key={Math.random()} />}
							/>
							<Route
								path="/shopAdmin/addProduct"
								render={() => <ShopAddProduct key={Math.random()} />}
							/>
							<Route
								path="/shopAdmin/addFood"
								render={() => <ShopAddProduct key={Math.random()} />}
							/>
							<Route
								path="/shopAdmin/editProduct/:id"
								render={(props) => <ShopEditProduct key={Math.random()} {...props} />}
							/>
							<Route
								path="/shopAdmin/editFood/:id"
								render={(props) => <ShopEditProduct key={Math.random()} {...props} />}
							/>
							<Route
								path="/shopAdmin/addProdcutInShopMenu/:shopMenuId"
								render={(props) => <ShopAddProduct key={Math.random()} {...props} />}
							/>
							<Route
								path="/shopAdmin/addFoodInShopMenu/:shopMenuId"
								render={(props) => <ShopAddProduct key={Math.random()} {...props} />}
							/>
							<Route path="/shopAdmin/editPromotion/:id" component={ShopEditPromotion} />
							<Redirect from="/shopAdmin" to="/shopAdmin/dashboard" />
						</Switch>
					</div>
				</div>
			</div>
		</Provider>
	);
}
